module.exports = __webpack_public_path__ + "img/jenkins.1522ce2f.png";